/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RelocateScreenerResident200ResponseData
 */
export interface RelocateScreenerResident200ResponseData {
    /**
     * 
     */
    resident_id: string;
    /**
     * 
     */
    bed_id: string;
}

/**
 * Check if a given object implements the RelocateScreenerResident200ResponseData interface.
 */
export function instanceOfRelocateScreenerResident200ResponseData(value: object): value is RelocateScreenerResident200ResponseData {
    if (!('resident_id' in value) || value['resident_id'] === undefined) return false;
    if (!('bed_id' in value) || value['bed_id'] === undefined) return false;
    return true;
}

export function RelocateScreenerResident200ResponseDataFromJSON(json: any): RelocateScreenerResident200ResponseData {
    return RelocateScreenerResident200ResponseDataFromJSONTyped(json, false);
}

export function RelocateScreenerResident200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelocateScreenerResident200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'resident_id': json['resident_id'],
        'bed_id': json['bed_id'],
    };
}

export function RelocateScreenerResident200ResponseDataToJSON(json: any): RelocateScreenerResident200ResponseData {
    return RelocateScreenerResident200ResponseDataToJSONTyped(json, false);
}

export function RelocateScreenerResident200ResponseDataToJSONTyped(value?: RelocateScreenerResident200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resident_id': value['resident_id'],
        'bed_id': value['bed_id'],
    };
}

